import { useState, useEffect } from 'react'

interface TimeLeft {
    days: number
    hours: number
    minutes: number
    seconds: number
}

export const useCountdown = (targetDate: string | null): [TimeLeft | null, boolean] => {
    const [timeLeft, setTimeLeft] = useState<TimeLeft | null>(null)
    const [isExpired, setIsExpired] = useState(false)

    useEffect(() => {
        if (!targetDate) {
            setTimeLeft(null)
            return
        }

        const calculateTimeLeft = (): TimeLeft => {
            const difference = +new Date(targetDate) - +new Date()

            if (difference <= 0) {
                setIsExpired(true)

                return { days: 0, hours: 0, minutes: 0, seconds: 0 }
            }

            return {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60),
            }
        }

        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft())
        }, 1000)

        setTimeLeft(calculateTimeLeft())

        return () => clearInterval(timer)
    }, [targetDate])

    return [timeLeft, isExpired]
}
